<section class="content-header">
  <h1 *ngIf="install != null">
    {{ install.nom }}
  </h1>
  <ol class="breadcrumb">
    <li><a><em class="fa fa-signal"></em> CAPA</a></li>
    <li i18n="@@Licenses">Licenses</li>
    <li class="active"> {{ install.nom }} </li>
  </ol>
</section>
<section class="content">
  <div class="row">
    <div class="col-md-6">
      <div class="box box-capa">
        <div class="box-header">
          <h3 class="box-title" i18n="@@informations">Informations</h3>
          <div class="box-tools">
            <button class="btn btn-box-tool" i18n-title title="Global synchronization" data-toggle="modal" data-target="#modal-sync"><em class="fa fa-cloud-download fa-2x" style="color: #545157"></em></button>
            <button class="btn btn-box-tool disabled" i18n-title title="Extend the rental period"><em class="fa fa-calendar-plus-o fa-2x"></em></button>
            <button class="btn btn-box-tool" i18n-title title="Modify install" data-toggle="control-sidebar"><em class="fa fa-edit fa-2x" style="color: #545157"></em></button>
            <button class="btn btn-box-tool disabled" i18n-title title="Activate license"><em class="fa fa-check-circle fa-2x"></em></button>
            <button class="btn btn-box-tool" i18n-title title="Delete" data-toggle="modal" data-target="#modal-delete"><em class="fa fa-trash fa-2x" style="color: #f44e00"></em></button>
          </div>
        </div>
        <div class="box-body">
          <ul class="list-group">
            <li class="list-group-item">
              <strong i18n="@@licenseNumber">License number</strong> <a class="pull-right">{{ install.idInstall }}</a>
            </li>
            <li class="list-group-item">
              <strong i18n="@@clientNumber">Client number</strong> <a class="pull-right">{{ install.numeroClient }}</a>
            </li>
            <li class="list-group-item">
              <strong i18n="@@initialRentDuration">Initial rent location</strong> <a class="pull-right"></a>
            </li>
            <li class="list-group-item">
              <strong i18n="@@activatedDate">Activated the </strong> <a class="pull-right">{{ install.activation | date: 'dd/MM/yyyy' }}</a>
            </li>
            <li class="list-group-item">
              <strong i18n="@@createdDate">Created the</strong> <a class="pull-right">{{ install.creeLe | date: 'dd/MM/yyyy HH:mm' }}</a>
            </li>
            <li class="list-group-item">
              <strong i18n="@@modifiedDate">Modified the</strong> <a class="pull-right">{{ install.modifieLe | date: 'dd/MM/yyyy HH:mm' }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="box box-capa">
        <div class="box-header">
          <h3 class="box-title" i18n="@@bases">Devices</h3>
          <div class="box-tools">
            <button class="btn btn-box-tool" (click)="showSearchBar()" i18n-title title="Search"><em class="fa fa-search fa-2x" style="color: #545157"></em></button>
            <button class="btn btn-box-tool" (click)="goToResults(install)" i18n-title title="See the tests"><em class="fa fa-headphones fa-2x" style="color: #545157"></em></button>
          </div>
        </div>
        <div class="box-body">
          <div id="search-bar-div" class="container-fluid search-bar-div">
              <input id="base-search-bar" type="text" class="form-control" i18n-placeholder placeholder="Enter a device identifier" style="margin-bottom: 2.5%" (keyup)="getPagedBases()" />
          </div>

          <div class="container-fluid" *ngFor="let base of bases">
            <a class="fa fa-trash fa-2x base-button devices-buttons" style="color: red;" data-toggle="modal" data-target="#modal-delete" (click)="setBaseToInteract(base)" i18n-title title="Delete"></a>
            <a class="fa fa-cloud-download fa-2x base-button devices-buttons" data-toggle="modal" data-target="#modal-sync" (click)="setBaseToInteract(base)" i18n-title title="Global synchronization"></a>
            <a class="fa fa-credit-card fa-2x base-button devices-buttons" data-toggle="modal" data-target="#modal-credit" (click)="setBaseToInteract(base)" i18n-title title="Add credit(s)"></a>
              <span class="badge bg-blue-gradient" style="float: right; margin: 0.55% 0% 0% 1%; font-size: small;"> {{ base.nbCredits }} <span i18n="@@credits">Credit(s)</span></span>

            <em class="fa fa-tablet fa-5x" style="float: left; margin-right: 20px"></em>
            <strong>{{ base.organisation + " (" + base.nomUtilisateur + " " + base.prenomUtilisateur + ")" }}</strong>
            <p style="margin-bottom: 0">{{ base.idBase + " version " + base.version }}</p>
            <p>{{ base.imei }}</p>
          </div>
            <div class="container-fluid" style="margin: 0 auto">
               <ngb-pagination
                        (pageChange)="getPagedBases($event)"
                        [maxSize]="10"
                        [rotate]="true"
                        [collectionSize]="nbTotalElements"
                        [pageSize]="nbElementsPerPage"
                        [(page)]="page">
               </ngb-pagination>
            </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- MODAL : Ensure delete -->
<div class="modal modal-danger fade in" id="modal-delete" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span></button>
          <h4 class="modal-title"><span class="fa fa-exclamation-circle"></span> <span i18n="@@deletion">DELETION</span></h4>
      </div>
      <div class="modal-body">
        <div *ngIf="baseToInteract === null; then delete_install else delete_base"></div>
          <ng-template #delete_install><p i18n="@@deleteLicenseWarning">XARNING ! Are you sure that you want to delete this license ?</p></ng-template>
          <ng-template #delete_base><p i18n="@@deleteBaseWarning">WARNING ! Are you sure that you want to delete this device ?</p></ng-template>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" (click)="this.baseToInteract = null;" i18n="@@cancel">Cancel</button>

        <div *ngIf="baseToInteract === null; then func_delete_install else func_delete_base "></div>
          <ng-template #func_delete_install><button type="button" class="btn btn-outline" data-dismiss="modal" (click)="deleteInstall()" i18n="@@confirm">Confirm</button></ng-template>
          <ng-template #func_delete_base><button type="button" class="btn btn-outline" data-dismiss="modal" (click)="deleteBase(this.baseToInteract)" i18n="@@confirm">Confirm</button></ng-template>
      </div>
    </div>
  </div>
</div>

<!-- MODAL : Ensure sync -->
<div class="modal modal-warning fade in" id="modal-sync" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" (click)="baseToInteract = null" aria-label="Close">
                    <span aria-hidden="true">×</span></button>
                <h4 class="modal-title"><span class="fa fa-exclamation-circle"></span> <span i18n="@@globalSync">GLOBAL SYNCHRONIZATION</span></h4>
            </div>
            <div class="modal-body">
                <div *ngIf="baseToInteract"><p i18n="@@syncBaseWarning">WARNING ! Are you sure you want to request global synchronization of this device ?</p></div>
                <div *ngIf="!baseToInteract"><p i18n="@@syncLicenseWarning">WARNING ! Are you sure you want to request global synchronization of this license ?</p></div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" (click)="baseToInteract = null;" i18n="@@cancel">Cancel</button>
                <div *ngIf="baseToInteract"><button type="button" class="btn btn-outline" data-dismiss="modal" (click)="syncBase(baseToInteract)" i18n="@@confirm">Confirm</button></div>
                <div *ngIf="!baseToInteract"><button type="button" class="btn btn-outline" data-dismiss="modal" (click)="syncAllBases()" i18n="@@confirm">Confirm</button></div>
            </div>
        </div>
    </div>
</div>


<!-- MODAL : add credits -->
<div class="modal modal-warning fade in" id="modal-credit" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" (click)="baseToInteract = null" aria-label="Close">
                    <span aria-hidden="true">×</span></button>
                <h4 class="modal-title"><span class="fa fa-exclamation-circle"></span> <span i18n="@@addCredits">ADD CREDIT(S)</span></h4>
            </div>
            <div class="modal-body">
                <p i18n="@@howManyCreditsQuestion">How many credit(s) do you want to add ?</p>
                <input type="number" *ngIf="credit == null" placeholder="Amount of credit(s)" class="form-control credits-field" [(ngModel)]="nbCreditsToAdd" />
                <input type="text" *ngIf="credit != null" class="form-control credits-field" [(ngModel)]="credit" disabled/>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" (click)="baseToInteract = null; credit = null;" i18n="@@ngb.alert.close">Close</button>
                <button type="button" class="btn btn-outline" (click)="generateCredits()" i18n="@@confirm">Confirm</button>
            </div>
        </div>
    </div>
</div>

<aside class="control-sidebar control-sidebar-dark">
    <div class="p-3">
        <app-license-sidebar [install]="install"></app-license-sidebar>
    </div>
</aside>
<div class="control-sidebar-bg"></div>
